import textStyle from "./text.module.css"
import { useModal } from "modal/provider"


export default function QQQ(props) {

    const { modal_close } = useModal()

    const scheduleInfo = props['scheduleInfo']
    const branch_name = scheduleInfo['branchName']
    const event_name = scheduleInfo['Event']['name']

    return(
        <div className={textStyle['wrap']}>
            <div className={textStyle['title']}>사고력수학 시매쓰 개인정보 수집·이용, 법정대리인 동의서</div>

            <div className={textStyle['content']}>
                <div style={{textAlign: "justify"}}>
                    <span className={textStyle['bold']}>시매쓰 {branch_name}</span>, <span className={textStyle['bold']}>주식회사 오메가포인트</span>(사고력수학 시매쓰)는 다음과 같이 공동으로 {event_name} 등을 위한 최소한의 개인정보를 수집하여 처리합니다. 처리하고 있는 개인정보는 다음 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. 또한 <span className={textStyle['bold']}>시매쓰 {branch_name}</span>, <span className={textStyle['bold']}>주식회사 오메가포인트</span>는 개인정보를 제3자에게 제공하지 않으며, 제공하게 될 경우 별도의 동의를 받는 등 법령이 정하는 바에 따라 필요한 조치를 이행할 예정입니다.
                </div>

                <br></br>

                <div>
                    <table className={textStyle['table']}>
                        <thead></thead>
                        <tbody>
                            <tr>
                                <th style={{width: "20%"}}>수집하는 자</th>
                                <td colSpan={2}><span className={textStyle['bold']}>시매쓰 {branch_name}</span>, <span className={textStyle['bold']}>주식회사 오메가포인트</span> (사고력수학 시매쓰 본사)</td>
                            </tr>
                            <tr>
                                <th rowSpan={2}>개인정보 수집·이용 목적</th>
                                <th style={{width: "20%"}}>학원서비스</th>
                                <td>{event_name} 운영과 관리</td>
                            </tr>
                            <tr>
                                <th>마케팅 및 광고</th>
                                <td>행사 홍보 등 광고성 정보 전달</td>
                            </tr>
                            <tr>
                                <th>수집하는 개인정보 항목</th>
                                <td colSpan={2} style={{textAlign: "justify"}}>
                                    <div className={textStyle['indent']}>1. 이번 신청 시 수집하는 개인정보</div>
                                    <div style={{marginLeft: "18px"}}><span className={textStyle['bold']}>학생</span> 성명, <span className={textStyle['bold']}>학생</span> 성별, <span className={textStyle['bold']}>학생</span> 학년, <span className={textStyle['bold']}>학생</span> 주소, <span className={textStyle['bold']}>학부모(법정대리인)</span> 휴대전화번호</div>
                                    <br></br>
                                    <div className={textStyle['indent']}>2. {event_name} 이후 추가로 수집하는 개인정보</div>
                                    <div style={{marginLeft: "18px"}}><span className={textStyle['bold']}>학생</span> 생년월일, <span className={textStyle['bold']}>학생</span> 소속 교육기관(유치원, 학교 등), <span className={textStyle['bold']}>학생</span> 휴대전화번호, <span className={textStyle['bold']}>학생</span> 나이, <span className={textStyle['bold']}>학부모(법정대리인)</span> 성명, <span className={textStyle['bold']}>학부모(법정대리인)</span> 전자우편주소, <span className={textStyle['bold']}>학부모(법정대리인)</span>와 <span className={textStyle['bold']}>학생</span>간 관계</div>
                                </td>
                            </tr>
                            <tr>
                                <th>개인정보 보유 및 이용기간</th>
                                <td colSpan={2} style={{textAlign: "justify"}}>
                                    <div className={textStyle['indent'] + ' ' + textStyle['bold']}><span style={{fontWeight: "normal"}}>○</span> 학원 등록 여부와 상관 없이 최신 교육정보·학원소식 전달, 학원 홍보 등을 위해 시매쓰 {branch_name}, 주식회사 오메가포인트가 위 개인정보를 보유 및 이용하는 것에 <span className={textStyle['underline']}>동의하는 경우</span></div>
                                    <div className={textStyle['underline']} style={{marginLeft: "20px"}}>⇒ {event_name} 종료일로부터 5년 간</div>
                                    <br></br>
                                    <div className={textStyle['indent'] + ' ' + textStyle['bold']}><span style={{fontWeight: "normal"}}>○</span> 학원 등록 여부와 상관 없이 최신 교육정보·학원소식 전달, 학원 홍보 등을 위해 시매쓰 {branch_name}, 주식회사 오메가포인트가 위 개인정보를 보유 및 이용하는 것에 <span className={textStyle['underline']}>동의하지 않는 경우</span></div>
                                    <div className={textStyle['underline']} style={{marginLeft: "20px"}}>⇒ {event_name} 종료일까지</div>
                                    <br></br>
                                    <div className={textStyle['indent']}>※ 단, 「전자상거래법」, 「전자금융거래법」 등 다른 법령에서 정하는 바에 따라 개인정보를 의무적으로 보존해야하는 경우에는 해당 법령에서 정하는 기간 동안 개인정보를 보존합니다. (「개인정보 보호법」 제21조 1항)</div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot></tfoot>
                    </table>
                </div>

                <br></br>

                <div className={textStyle['indent']} style={{textAlign: "justify"}}>1. <span className={textStyle['bold']}>(개인정보 수집 및 이용 동의)</span> 귀하께는 동의하지 않을 권리가 있습니다. 동의하시지 않을 경우, <span className={textStyle['underline']}>위 개인정보 수집·이용 목적에 포함된 {event_name} 이용이 제한됨</span>을 알려드립니다.</div>

                <br></br>

                <div className={textStyle['indent']} style={{textAlign: "justify"}}>2. <span className={textStyle['bold']}>(개인정보 마케팅 및 광고 활용 동의)</span> 귀하께는 동의하지 않을 권리가 있으며, 마케팅 및 광고 활용에 동의하시지 않더라도 {event_name} 이용에는 불이익이 없습니다. 다만, <span className={textStyle['underline']}>동의하시지 않을 경우</span>, {event_name} 이용 외 <span className={textStyle['underline'] + ' ' + textStyle['bold']}>행사, 신규강의 홍보 등에 관한 정보 제공</span>이 제한됩니다.</div>

                <br></br>

                <div className={textStyle['indent']} style={{textAlign: "justify"}}>3. <span className={textStyle['bold']}>(개인정보 보유기간에 관한 추가 동의)</span> <span className={textStyle['underline'] + ' ' + textStyle['bold']}>최신 교육정보·학원소식 전달, 학원 홍보 등</span>을 위해, 학원 등록 여부와 상관 없이, 즉 위 개인정보의 수집·이용 목적이 달성된 이후에도 <span className={textStyle['underline']}>{event_name} 종료일로부터 5년 간</span> 위 개인정보를 보유 및 이용하는 것에 동의하시나요? 귀하께는 동의하지 않을 권리가 있으며, 동의하시지 않더라도 {event_name} 이용에는 불이익이 없습니다. <span className={textStyle['underline']}>동의하시지 않을 경우</span>, 학원 등록 상태가 아닐 때 <span className={textStyle['underline'] + ' ' + textStyle['bold']}>최신 교육정보·학원소식 전달, 학원 홍보 등 정보 제공</span>이 제한됩니다.</div>

                <br></br>

                <div className={textStyle['indent']} style={{textAlign: "justify"}}>4. 학생이 만 14세 미만 아동인 경우 법정대리인 동의가 필요합니다.</div>
            </div>

            <div
                className={textStyle['button']}
                onClick={() => modal_close()}
            >확인</div>
        </div>
    )
}